import { atom } from "jotai";
export const openCreateTeamDialogAtom = atom(false);
export const openEditTeamDialogAtom = atom(false);
export const editTeamIdAtom = atom(0);